/**
 * @desc 使用axios作为通用http支持
 */
import axios from './axios';
import { requestInterceptor } from './requestSign';
import { getBlackBox, waitBlackBox } from './tongdunAutoLoad';
import tongdunReport from './tongdunReport';
import prepareTongdunBody from './tongdunBody';
import { IsIOS, IsAndroid } from './uaInfo';

const KEWLHttp = axios;
/** 配置 tongdunBlackBox=true 时默认等待同盾 black_box 的时长。 */
const defaultTongdunWaitTimeout = 4000;

window.KEWLHttp = KEWLHttp;

// 接口签名 https://www.tapd.cn/22586881/prong/stories/view/1122586881001044391
axios.interceptors.request.use(requestInterceptor);

// 公共拦截器逆序执行：按需等待并合并公参，再补齐 body，最后签名。
KEWLHttp.interceptors.request.use(prepareTongdunBody);

// 所有接口按照多包适配，增加多包接口参数
if (window.KEWLApp && window.KEWLApp.getAlias) {
  // 不同包在接口的标识字段
  const alias = window.KEWLApp.getAlias();
  KEWLHttp.interceptors.request.use((config) => {
    /**
     * 合并同盾 black_box 和多包公共参数。
     * @param {string} blackBox 同盾 black_box
     * @returns {AxiosRequestConfig} axios 请求配置
     */
    const mergeCommonParams = (blackBox) => {
      const tongdunBlackBox = blackBox || getBlackBox();
      // --story=1077986 --user=likunting 【h5】注册登录接口新增埋点 https://www.tapd.cn/22586881/s/2216190
      !tongdunBlackBox && tongdunReport(config);
      const params = {
        alias, // alias=us 美国包，alias=ar中东包， alias=liveme //主包
        tongdun_black_box: tongdunBlackBox,
        // eslint-disable-next-line no-nested-ternary
        os: IsIOS ? 'iOS' : IsAndroid ? 'android' : 'web'
        // ver: window.KEWLApp.getVerName() || ''
      };
      // --story=1046618 --user=likunting 数美SDK接入 https://www.tapd.cn/22586881/s/1706831
      // if (window.SM_deviceId2) {
      //   params.smidv2 = window.SM_deviceId2;
      // }
      config.params = Object.assign({}, params, config.params);
      const configTongdunBlackBox = config.params.tongdun_black_box;
      if (
        tongdunBlackBox
        && (
          configTongdunBlackBox === undefined
          || configTongdunBlackBox === null
          || configTongdunBlackBox === ''
          || configTongdunBlackBox === '1'
        )
      ) {
        config.params.tongdun_black_box = tongdunBlackBox;
      }
      return config;
    };

    /**
     * 获取当前请求配置的同盾等待超时时间。
     * @returns {number} 同盾等待超时时间，单位毫秒
     */
    const getTongdunWaitTimeout = () => {
      const timeout = Number(config.tongdunBlackBoxTimeout);
      return timeout > 0 ? timeout : defaultTongdunWaitTimeout;
    };

    /**
     * 支持请求级同盾配置：
     * - tongdunBlackBox=true：等待同盾 black_box 后再合并公共参数；
     * - tongdunBlackBoxTimeout：自定义等待时长，单位毫秒。
     */
    if (config.tongdunBlackBox === true) {
      return waitBlackBox(getTongdunWaitTimeout()).then(mergeCommonParams).catch(() => mergeCommonParams(''));
    }

    return mergeCommonParams('');
  });
}

/**
 * 拦截特殊的接口返回状态，提示信息
 * 根据系统语言显示弹窗文案
 * 统计：接口地址，接口状态，接口msg
 */
require('./error_message.js');

let interLang = '';
const arrInterLang = ['en', 'zh', 'es', 'ja', 'id', 'pt', 'ar', 'de'];
function getLang() {
  return navigator.language.toLowerCase();
}
function checkIsExist(lang) {
  if (arrInterLang.indexOf(lang) > -1) {
    lang = lang;
  } else if (arrInterLang.indexOf(lang.split('-')[0]) > -1) {
    lang = lang.split('-')[0];
  } else {
    lang = '';
  }
  return lang;
}
interLang = checkIsExist(getLang()) || 'en';

window.KEWLSensor.register('kewlweb_onerror_type3_restimes', {
  starttime: 0,
  errormsg: '',
  target: '',
  errortype: 0,
  webresponsetimes: 1,
  pageid: 0
});

// 非200的上报
window.KEWLSensor.register('kewlweb_onerror_type7_unres200', {
  starttime: 0,
  errormsg: '', // 错误msg
  errorstatus: 0, // 错误status
  target: '',
  params: {},
  errortype: 0,
  webresponsetimes: 1,
  pageid: 0
});

window.KEWLSensor.register('kewlweb_onerror_type4_res400', {
  starttime: 0,
  errormsg: '',
  target: '',
  errortype: 0,
  webresponsetimes: 1,
  pageid: 0
});

window.KEWLSensor.register('kewlweb_onerror_type5_res500', {
  starttime: 0,
  errormsg: '',
  target: '',
  errortype: 0,
  webresponsetimes: 1,
  pageid: 0
});

window.KEWLSensor.register('kewlweb_onerror_type6_resother', {
  starttime: 0,
  errormsg: '',
  target: '',
  errortype: 0,
  webresponsetimes: 1,
  pageid: 0
});

try {
  KEWLHttp.interceptors.request.use((config) => {
    config.metadata = {
      startTime: new Date()
    };

    return config;
  }, (error) => {
    console.log(error);
    return Promise.reject(error);
  });

  KEWLHttp.interceptors.response.use((response) => {
    try {
      response.duration = new Date() - response.config.metadata.startTime;

      window.KEWLSensor.track('kewlweb_onerror_type3_restimes', {
        starttime: response.config.metadata.startTime.getTime(),
        errormsg: '',
        target: response.config.url,
        errortype: 3,
        webresponsetimes: response.duration,
        pageid: 0
      });
      // 风控拦截弹窗
      const oneSts = response.data && response.data.status;
      const secSts = response.data && response.data.data && response.data.data.status;
      if (window.errorMessageTMX[oneSts] || window.errorMessageTMX[secSts]) {
        const errObj = window.errorMessageTMX[oneSts] || window.errorMessageTMX[secSts];
        const errMsg = errObj[interLang];
        const msgDIV = document.createElement('div');
        msgDIV.className = 'error-message-tmx';
        msgDIV.style.background = 'rgba(0,0,0,.6)';
        msgDIV.style.position = 'fixed';
        msgDIV.style.top = '40%';
        msgDIV.style.left = '50%';
        msgDIV.style.width = '300px';
        msgDIV.style.marginLeft = '-150px';
        msgDIV.style.padding = '0.3rem';
        msgDIV.style.color = '#fff';
        msgDIV.style.borderRadius = '4px';
        msgDIV.style.boxSizing = 'border-box';
        msgDIV.style.fontSize = '0.4rem';
        msgDIV.style.zIndex = '999999999999999';
        msgDIV.style.textAlign = 'center';
        msgDIV.style.lineHeight = '0.5rem';
        msgDIV.style.display = 'block';
        msgDIV.innerHTML = errMsg;
        document.body.appendChild(msgDIV);
        setTimeout(() => {
          msgDIV.style.display = 'none';
          document.body.removeChild(msgDIV);
        }, 5000);

        console.log('interceptors', errMsg);
      }
      // 非200上报
      if (response.status == 200 && oneSts && response.data.status != 200) {
        const { status, msg } = response.data;
        const { metadata, url } = response.config;
        // 因为post和get参数类型不同，post参数处理导致返回的内容又不同
        const getRequestParametersStr = ({ method, data, params }) => {
          try {
            let parameters;
            const methodLower = method.toLowerCase();
            if (methodLower === 'get') {
              parameters = params;
            } else if (methodLower === 'post') {
              let postData = {};
              try { // 处理qs转换的数据
                postData = JSON.parse(data);
              } catch (e) {
                // transformData情况
                if (typeof data === 'string') {
                  data.split('&').forEach((item) => {
                    [key, value] = item.split('=');
                    key && (postData[key] = value);
                  });
                }
              }
              // 合并get参数
              parameters = Object.assign({}, params || {}, postData);
            }
            return parameters ? Object.keys(parameters).map(key => `${key}=${parameters[key]}`).join('&') : '';
          } catch (e) {
            window.KEWLError.report({
              errorMsg: '处理接口非200参数时出现错误',
              target: url,
              errorType: 1
            });
            return '';
          }
        };
        window.KEWLSensor.track('kewlweb_onerror_type7_unres200', {
          starttime: metadata.startTime.getTime(),
          errormsg: msg, // 错误提示
          errorstatus: status, // 错误status
          params: getRequestParametersStr(response.config), // 接口参数
          target: url,
          errortype: 7,
          webresponsetimes: response.duration,
          pageid: 0
        });
        console.log('data+++++', response.config.url, getRequestParametersStr(response.config));
      }
    } catch (err) {
      console.log('interceptors-err', err);
    }
    return response;
  },
  (error) => {
    // console.log(error);
    error.duration = new Date() - error.config.metadata.startTime;
    const res = error.response;
    if (!res) {
      window.KEWLSensor.track('kewlweb_onerror_type6_resother', {
        starttime: error.config.metadata.startTime.getTime(),
        errormsg: JSON.stringify(error),
        target: error.config.url,
        errortype: 6,
        webresponsetimes: error.duration,
        pageid: 0
      });
    } else if (res.status >= 400 && res.status < 500) {
      window.KEWLSensor.track('kewlweb_onerror_type4_res400', {
        starttime: error.config.metadata.startTime.getTime(),
        errormsg: JSON.stringify(error),
        target: error.config.url,
        errortype: 4,
        webresponsetimes: error.duration,
        pageid: 0
      });
    } else if (res.status >= 500 && res.status < 600) {
      window.KEWLSensor.track('kewlweb_onerror_type5_res500', {
        starttime: error.config.metadata.startTime.getTime(),
        errormsg: JSON.stringify(error),
        target: error.config.url,
        errortype: 5,
        webresponsetimes: error.duration,
        pageid: 0
      });
    } else {
      window.KEWLSensor.track('kewlweb_onerror_type6_resother', {
        starttime: error.config.metadata.startTime.getTime(),
        errormsg: JSON.stringify(error),
        target: error.config.url,
        errortype: 6,
        webresponsetimes: error.duration,
        pageid: 0
      });
    }

    return Promise.reject(error);
  });
} catch (err) {
  console.log('interceptors', err);
  window.KEWLSensor.track('kewlweb_onerror_type6_resother', {
    errormsg: JSON.stringify(err),
    errortype: 6
  });
}
export default KEWLHttp;
